import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { environment } from '../../../environments/environment';
import { Role } from '../entities/user/role.enum';
import { User } from '../entities/user/user.model';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent {

    @Input()
    loggedUser: User;

    @Input()
    supportedLanguages: {flagCode: string, langCode: string}[] = [{flagCode: 'it', langCode: 'it-IT'}, {flagCode: 'gb', langCode: 'en-GB'}];

    @Input()
    selectedLanguage?: string;

    roles = Role;

    @Output()
    toggleSidenav = new EventEmitter<void>();

    @Output()
    logout = new EventEmitter<void>();

    @Output()
    setSelectedLanguage = new EventEmitter<string>();

    get version() {
        return environment.version;
    }

    get year(){
        return new Date().getFullYear();
    }

    public closeSidenav() {
        this.toggleSidenav.emit();
    }

    public onLogout() {
        this.logout.emit();
    }

    public setLanguage(lang: string){
        this.setSelectedLanguage.emit(lang);
    }
}
